import { useState } from 'react';
import KaKaoIcon from '@/assets/icons/Monitoring/ri_kakao-talk-fill.svg?react';
import { usePost } from '@/api';
import { CPLAT_API_ROUTES } from '@/api';
import { useAppSelector } from '@/redux/store';
import { useMonitoringGoods } from './MonitoringContext';
import { useToast } from '@/hooks/V3/useToast';
import { useSearchParams } from 'react-router-dom';
import { useMembershipMonitoringPreviewTutorial } from '@/components/membership/MembershipMonitoringPreviewTutorial';

const Spinner = () => (
  <div className="absolute inset-0 z-10 flex items-center justify-center rounded-[8px] bg-white/60">
    <svg className="h-5 w-5 animate-spin text-gr-500" viewBox="0 0 24 24">
      <circle
        className="opacity-25"
        cx="12"
        cy="12"
        r="10"
        stroke="currentColor"
        strokeWidth="4"
        fill="none"
      />
      <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v8z" />
    </svg>
  </div>
);

const GiveMeAlarm = ({ isMockGoods }: { isMockGoods: boolean }) => {
  const user = useAppSelector((state) => state.user);
  const { refetch } = useMonitoringGoods();
  const { showToast } = useToast();
  const { openTutorial } = useMembershipMonitoringPreviewTutorial();
  const [isLoading, setIsLoading] = useState(false);
  const [searchParams] = useSearchParams();
  const goodsNo = searchParams.get('select');
  const { goods } = useMonitoringGoods();
  const selectedGoods = goods.find((item) => String(item.GoodsNo) === String(goodsNo));
  const { mutate: setMonitoringGoods } = usePost(CPLAT_API_ROUTES.setUserMonitoringGoods);

  // NoticeYn이 'Y'면 알림 그만받기, 아니면 알림 받기
  const isAlarmOn = selectedGoods?.NoticeYn === 'Y';
  const buttonText = isAlarmOn ? '알림 그만 받기' : '순위 알림 받기';
  const buttonBg = isAlarmOn ? 'bg-gr-200' : 'bg-[#FFE601]';

  const handleToggleAlarm = () => {
    if (openTutorial('toggleAlarm')) return;

    if (isMockGoods) {
      showToast('warning', '예시 상품은 알림 설정을 할 수 없어요');
      return;
    }
    if (!selectedGoods) {
      showToast('warning', '다시 시도해주세요');
      return;
    }

    setIsLoading(true);
    setMonitoringGoods(
      {
        cplatToken: user.CplatToken,
        GoodsNo: selectedGoods.GoodsNo,
        NoticeYn: isAlarmOn ? 'N' : 'Y',
        UseYn: 'Y',
        InsertYn: 'Y',
        StoreName: selectedGoods.StoreName,
      },
      {
        onSuccess: (res) => {
          const { code } = res.data;
          if (code === '200') {
            showToast(
              'success',
              isAlarmOn ? '알림톡이 해제되었습니다.' : '매일 오전 9시 순위 알림톡을 보내드려요!',
            );
            refetch();
          } else {
            showToast('warning', res.data.message || '알림톡 설정에 실패했습니다.');
          }
          setIsLoading(false);
        },
        onError: () => {
          showToast('warning', '알림톡 설정에 실패했습니다. 다시 시도해주세요.');
        },
        onSettled: () => {
          setIsLoading(false);
        },
      },
    );
  };

  return (
    <button
      type="button"
      className={`relative flex items-center gap-1 rounded-[8px] px-[10px] py-2 text-gr-800 transition-opacity Caption1M12 disabled:opacity-60 ${buttonBg}`}
      onClick={handleToggleAlarm}
      disabled={isLoading}
    >
      {isLoading && <Spinner />}
      <KaKaoIcon />
      <div>{buttonText}</div>
    </button>
  );
};

export default GiveMeAlarm;
